import React from "react";

import { ArrowLeft } from "react-feather";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

import TabMenu from "../components/TabMenu";

const CustomersDetailsTemplate = props => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const pageTitle = location.state.title
    ? location.state.title
    : "Detalhes do cliente";

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <div className="d-flex flex-row align-center">
          <div className="d-flex flex-row align-center">
            <button className="dropdown__btn rounded__btn mr-20" style={{ width: "34px", height: "34px" }} onClick={() => navigate("/customers")}>
              <ArrowLeft />
            </button>

            <span>{pageTitle}</span>
          </div>

          <div className="ml-30">
            <TabMenu items={[{
              name: "Informações",
              to: `/customers/${params.id}/`
            }, {
              name: "Lances",
              to: `/customers/${params.id}/bids`
            }, {
              name: "Arremates",
              to: `/customers/${params.id}/buy-in-auction`
            }]} />
          </div>
        </div>
      </div>

      <div className="dashboard__container">
        <Outlet />
      </div>
    </div >
  )
}

export default CustomersDetailsTemplate;